import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import { ErrorSnacktOpen } from "../../ErrorSnack/actions";
const download = require("downloadjs");

// //////////////////
// Action Creators //
// //////////////////

export const CargarDetalleSolicitud = (prestaciones) => ({
  type: "CARGAR_DETALLE_SOLICITUD",
  prestaciones,
});

export const CargarDetallesSolicitudPaquete = (prestaciones) => ({
  type: "CARGAR_DETALLE_SOLICITUD_PAQUETE",
  prestaciones,
});

export const CargarDetalleSolicitudCabecera = (solicitud) => ({
  type: "CARGAR_DETALLE_SOLICITUD_CABECERA",
  solicitud,
});

export const LoadingFile = loadingFile => ({
  type: "LOADINGFILE",
  loadingFile
})

// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const GetFileDetalleSolicitudExcel = (idSolicitud) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    IdSolicitud: idSolicitud,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/solicitudes/DetalleSolicitudFile`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.blob();
    })
    .then((blob) => {
      dispatch(LoadingFile(false))
      download(blob, `DetalleSolicitud_${idSolicitud}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    })
    .catch((error) => {
      dispatch(LoadingFile(false))
      trace.error("GetFileDetalleSolicitud", error);
      dispatch(ErrorSnacktOpen(
        "Error al descargar el detalle de la solicitud Excel:",
        error,
      ));
    });
};

export const GetDetalleSolicitudConvenioPaquete = (idSolicitud) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    IdSolicitud: idSolicitud,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/paquetes/GetDetalleSolicitudConvenioBOExcel/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.blob();
    })
    .then((blob) => {
      dispatch(LoadingFile(false))
      download(blob, `DetalleSolicitud_${idSolicitud}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    })
    .catch((error) => {
      dispatch(LoadingFile(false))
      trace.error("GetDetalleSolicitudConvenioPaquete", error);
      dispatch(ErrorSnacktOpen(
        "Error al descargar el detalle de la solicitud Excel:",
        error,
      ));
    });
};

export const GetDetalleSolicitudConvenioPaqueteR = (idSolicitud) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    IdSolicitud: idSolicitud,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/paquetes/GetDetalleSolicitudConvenioBOExcelPQ/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.blob();
    })
    .then((blob) => {
      dispatch(LoadingFile(false))
      download(blob, `DetalleSolicitud_${idSolicitud}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    })
    .catch((error) => {
      dispatch(LoadingFile(false))
      trace.error("GetDetalleSolicitudConvenioPaqueteR", error);
      dispatch(ErrorSnacktOpen(
        "Error al descargar el detalle de la solicitud Excel Reajuste Paquetes:",
        error,
      ));
    });
};

export const getDetalleSolBOConvnioReajusteExcel = (idSolicitud) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    IdSolicitud: idSolicitud,
    modulo: "web",
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/solicitudes/getDetalleSolBOConvnioReajusteExcel`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.blob();
    })
    .then((blob) => {
      dispatch(LoadingFile(false))
      download(blob, `DetalleSolicitud_${idSolicitud}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    })
    .catch((error) => {
      dispatch(LoadingFile(false))
      trace.error("GetFileDetalleSolicitud", error);
      dispatch(ErrorSnacktOpen(
        "Error al descargar el detalle de la solicitud de reajuste Excel:",
        error,
      ));
    });
};

export const GetDetalleSolicitud = (idSolicitud) => async (dispatch) => {
  const filtroBusquedaSRState = store.getState().filtroBusquedaSR;
  const solicitud = filtroBusquedaSRState.solicitudes.filter((s) => s.IdSolicitud === idSolicitud)[0];
  dispatch(CargarDetalleSolicitudCabecera(solicitud));

  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    IdSolicitud: idSolicitud,
    token: globalState.token,
  };

  await fetch(`${apiConfig.apiUri}/v1/solicitudes/GetDetalleSolicitud`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("GetDetalleSolicitud", json);
        dispatch(CargarDetalleSolicitud(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("GetDetalleSolicitud", error);
      dispatch(ErrorSnacktOpen(
        "Error al buscar el detalle de la solicitud:",
        error,
      ));
    });
};

export const GetDetalleSolicitudReajuste = (idSolicitud) => async (dispatch) => {
  const filtroBusquedaSRState = store.getState().filtroBusquedaSR;
  const solicitud = filtroBusquedaSRState.solicitudes.filter((s) => s.IdSolicitud === idSolicitud)[0];
  dispatch(CargarDetalleSolicitudCabecera(solicitud));

  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    IdSolicitud: idSolicitud,
    token: globalState.token,
  };

  await fetch(`${apiConfig.apiUri}/v1/solicitudes/getDetalleSolBOConvnioReajuste`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("GetDetalleSolicitudReajuste", json);
        dispatch(CargarDetalleSolicitud(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("GetDetalleSolicitudReajuste", error);
      dispatch(ErrorSnacktOpen(
        "Error al buscar el detalle de la solicitud de reajuste:",
        error,
      ));
    });
};

export const GetDetalleSolicitudPaquete = (idSolicitud) => async (dispatch) => {
  const filtroBusquedaSRState = store.getState().filtroBusquedaSR;
  const solicitud = filtroBusquedaSRState.solicitudes.filter((s) => s.IdSolicitud === idSolicitud)[0];
  dispatch(CargarDetalleSolicitudCabecera(solicitud));

  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    IdSolicitud: idSolicitud,
    token: globalState.token,
  };

  await fetch(`${apiConfig.apiUri}/v1/paquetes/GetDetalleSolicitudConvenioBO`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("GetDetalleSolicitudPaquete", json);
        dispatch(CargarDetallesSolicitudPaquete(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("GetDetalleSolicitudPaquete", error);
      dispatch(ErrorSnacktOpen(
        "Error al buscar el detalle de la solicitud de paquetes:",
        error,
      ));
    });
};

export const GetDetalleSolicitudReajustePQ = (idSolicitud) => async (dispatch) => {
  const filtroBusquedaSRState = store.getState().filtroBusquedaSR;
  const solicitud = filtroBusquedaSRState.solicitudes.filter((s) => s.IdSolicitud === idSolicitud)[0];
  dispatch(CargarDetalleSolicitudCabecera(solicitud));

  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    IdSolicitud: idSolicitud,
    token: globalState.token,
  };

  await fetch(`${apiConfig.apiUri}/v1/paquetes/GetDetalleSolicitudConvenioReajusteBO`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("GetDetalleSolicitudReajuste", json);
        dispatch(CargarDetalleSolicitud(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("GetDetalleSolicitudReajustePQ", error);
      dispatch(ErrorSnacktOpen(
        "Error al buscar el detalle de la solicitud de reajuste de paquetes:",
        error,
      ));
    });
};


// WEBPACK FOOTER //
// ./src/components/SolicitudesRealizadas/DetalleSolicitud/actions.js